<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;"></h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Ayarlar</li>
            <li class="breadcrumb-item active"><a routerLink="/portal">Portaller</a></li>
            <li class="breadcrumb-item active">Portal Ekle</li>
        </ol>
    </div>
    <div class="container">
        <div class="card mb-4">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h3 class="m-0 font-weight-bold" style="color: #1A355E;">Portal Ekle</h3>
            </div>
            <br>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="add()">
                    <div>
                        <fieldset>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Portal Adı</span></label>

                                    <div class="input-valid">
                                        <input pInputText type="txt" class="form-control" formControlName="portalName"
                                            autofocus />
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('portalName').hasError('required')&& form.get('portalName').touched">Portal
                                            Adı boş geçilemez!</small>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Portal Url</span></label>

                                    <input pInputText type="txt" class="form-control" formControlName="portalUrl"
                                        autofocus />

                                </div>
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Rapor Etiketi 1</span></label>

                                    <input pInputText type="txt" class="form-control" formControlName="reportTag1"
                                        autofocus />

                                </div>
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Rapor Etiketi 2</span></label>

                                    <input pInputText type="txt" class="form-control" formControlName="reportTag2"
                                        autofocus />

                                </div>
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Rapor Etiketi 3</span></label>

                                    <input pInputText type="txt" class="form-control" formControlName="reportTag3"
                                        autofocus />

                                </div>


                            </div>
                            <div class="col-md-12 text-right">
                                <div class="btn-group" role="group" aria-label="Basic example">
                                    <button pButton type="button" class="p-button-rounded p-button-danger"
                                        label="Vazgeç" routerLink="/portal"></button>
                                    <button pButton type="submit" class="p-button-rounded p-button-success"
                                        label="Kaydet" [disabled]="!form.valid"></button>
                                </div>
                            </div>

                        </fieldset>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>